import { fipClientSelectPageRoute } from './FipClientSelectPage/route';
import { fipHomeRoute } from './FipHomePage/route';
import { fipRoute } from './route';

export const fipRoutes = fipRoute.addChildren([
	fipHomeRoute,
	fipClientSelectPageRoute,
]);
